import {
  AppBar,
  DefaultCenterArea,
  DefaultEndArea,
  DefaultStartArea,
} from "../AppBar";

import { PropsWithChildren } from "react";

export const DefaultLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex flex-col h-lvh w-full">
      <AppBar
        slots={{
          start: <DefaultStartArea />,
          center: <DefaultCenterArea />,
          end: <DefaultEndArea />,
        }}
      />
      <div className="flex flex-col items-center flex-1 pt-4 overflow-auto">
        {children}
      </div>
    </div>
  );
};
